import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const CourseCompletions = () => {
  return <ReportSectionPage scope="org-admin" section="course-completions" title="Course Completions Report" />;
};

export default CourseCompletions;
